module.exports = __webpack_public_path__ + "static/media/diners.6a108b0c.png";